
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {

  const accessTokenGoogle = localStorage.getItem('accessTokenGoogle');
  const departmentAccessToken = localStorage.getItem('departmentAccessToken');
  const clientAccessTokenGoogle = localStorage.getItem('clientAccessTokenGoogle');

  if (!accessTokenGoogle && !departmentAccessToken && !clientAccessTokenGoogle) {

    return <Navigate to="/portal/onboarding" replace />;
  }


  return <Outlet />;
};

export default ProtectedRoute;